<template>
    <div id="message_detail">
        <div class="message_detail">
            <div class="message_detail1">
                <div class="message_detail1_1 cursor_1" style="z-index: 1;" @click="goBack">
                    <img src="../assets/image/icon_right.png" alt="">
                    返回
                </div>
                <div style="position: absolute;width: 100%;text-align: center;font-size: 22px;left: 0;right: 0;">
                    {{ result?.title }}
                </div>
            </div>
            <div class="message_detail2" @mousewheel="onMousewheelClick">
                <div v-html="html">
                </div>
                <div v-if="result && result?.vip && !!showVipLook()" class="noVip">
                    <div class="noVip_main" @click="openVip">
                        <p>仅限VIP用户学习哦~</p>
                        <p><svg-icon iconClass="lock" class="t-m-r-5"></svg-icon>解锁全部课程</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { EventBus } from '@/utils/eventBus'
// import { marked } from 'marked';
import api from '@/api/api';
export default {
    props: {
        detailId: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            html: '',
            resizeHandler: null,
            result: null,
        }
    },
    created() {
        this.getUserLoginState(false)
    },
    mounted() {
        if (this.detailId) {
            this.getDynamicsDetail(this.detailId)
        }
        this.handleVideoResize(); // 初始调整一次
        // 窗口大小改变时也重新调整
        window.addEventListener('resize', this.handleVideoResize);
    },
    beforeDestroy() {
        // 确保处理函数存在后再移除
        if (this.handleVideoResize) {
            window.removeEventListener('resize', this.handleVideoResize);
        }
    },
    methods: {
        onMousewheelClick(e) {
            if (this.result && this.result?.vip && !!this.showVipLook()) {
                e.preventDefault()
            }
        },
        showVipLook() {
            if (this.loginState) {
                return true
            }
            if (this.mixinUserInfo) {
                const vipItem = this.getUserTypeImg(this.mixinUserInfo)
                console.log('看下用户类型=', vipItem)
                if (['普通会员'].includes(vipItem.name)) {
                    console.log('用户是普通会员')
                    return true
                }
            }
            return false
        },
        getDynamicsDetail(id) {
            api.messageDetail({ id }).then((res) => {
                if (res.code === 200) {
                    // 创建Shadow DOM容器
                    this.result = res.data
                    this.html = res.data?.answer;
                    this.$nextTick().then(() => {
                        // 获取所有视频iframe
                        const videoIframes = document.querySelectorAll('.ql-video');

                        videoIframes.forEach(iframe => {
                            // 设置宽度为100%
                            iframe.style.width = '50%';

                            // 根据宽度计算高度(16:9比例)
                            const width = iframe.offsetWidth;
                            iframe.style.height = (width * 9 / 16) + 'px';
                        });
                    })
                }


            })
        },
        handleVideoResize() {
            this.$nextTick().then(() => {
                const videoIframes = document.querySelectorAll('.ql-video');
                videoIframes.forEach(iframe => {
                    const width = iframe.offsetWidth;
                    iframe.style.height = (width * 9 / 16) + 'px';
                });
            });
        },
        goBack() {
            this.$emit('goBack')
        },
        openVip() {
            if(this.loginState){
                EventBus.$emit('openLogin')
                return
            }
            EventBus.$emit('openVip')
        }
    }

}
</script>

<style lang="scss" scoped>
#message_detail {
    flex: 1;
    height: 100%;
    padding: 16px 0 0 20px;
    font-size: 15px;
    line-height: 1.2;
}

.message_detail {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    position: relative;
}

.message_detail1 {
    display: flex;
    align-items: center;
    height: 77px;
    border-bottom: 1px solid #E6EBF0;
    padding: 0 20px;

}

.message_detail1_1 {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    color: #111111;

}

.message_detail1_1 img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
}

.message_detail2 {
    width: 100%;
    height: calc(100% - 77px);
    padding: 25px 20px;
    overflow-y: auto;
    @include scrollbar();
    &:hover{
        @include scrollbar_hover()
    }
    img {
        object-fit: cover;
    }
}

.mask {
    background: -webkit-linear-gradient(180deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, .61) 42%, #fff);
}

.noVip {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-top: 120px;
    text-align: center;

    &::before {
        content: " ";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 120px;
        background: -webkit-gradient(linear, left top, left bottom, from(hsla(0, 0%, 100%, 0)), color-stop(42%, hsla(0, 0%, 100%, .61)), to(#fff));
        // background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, .61) 42%, #fff);
    }

    .noVip_main {
        overflow: hidden;
        color: #fc5531;
        // border: 1px solid transparent;
        width: 100%;
        height: 120px;
        text-align: center;
        background: #fff;
        font-size: 16px;
        padding-bottom: 40px;
    }
}
</style>